import React from "react";
import { StyledPercentageChange, Value, Icon } from "./PercentageChange.styles";

import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

const PercentageChange = ({ value, color }) => {
  const { t } = useTranslation();

  let styles = {};

  if (value > 0) {
    styles.transform = "scale(1, -1)";
  }
  // let icon = value > 0 ?  : arrowDecrease;

  const change = (Math.round(value * 100) / 100).toFixed(1);

  return (
    <StyledPercentageChange data-testid="percentage-change">
      <Icon
        width="26px"
        height="22px"
        viewBox="0 0 16 13"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        role="img"
        aria-label={
          value > 0 ? t("percentage.increaseOf") : t("percentage.decreaseOf")
        }
        data-testid="percentage-change_icon"
        style={styles}
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-251.000000, -762.000000)" fill={color}>
            <path d="M262.800849,762.225666 C262.800849,762.225666 264.674758,761.792373 264.750585,762.875408 C264.82601,763.958836 264.975648,764.717196 264.787693,765.944531 C264.600544,767.172258 264.563033,768.292153 264.674758,768.869353 C264.787693,769.447338 264.750585,769.700255 264.750585,769.700255 C264.750585,769.700255 266.775343,769.410871 266.962492,769.591638 C267.150448,769.772405 266.625301,770.313531 265.537902,770.999741 C264.450905,771.68595 261.26292,773.310895 261.26292,773.310895 C261.26292,773.310895 260.738581,773.599888 260.4389,773.780655 C260.13801,773.96103 259.238969,774.683315 259.013503,774.827615 C258.788844,774.972307 258.413739,775.188757 257.964017,774.683315 C257.513892,774.17748 256.576534,773.671646 255.863835,773.239137 C255.15154,772.805453 254.139161,772.227468 253.614418,771.722418 C253.089272,771.216975 251.551747,770.33196 251.289577,770.079435 C251.027407,769.82691 250.764431,769.465375 251.364598,769.50145 C251.964362,769.537525 252.977144,769.844555 253.277228,769.772405 C253.576908,769.700255 253.239314,768.977578 253.239314,768.292153 C253.239314,767.605943 253.351845,766.233915 253.314335,765.764548 C253.277228,765.294788 253.126783,764.283903 253.089272,763.633768 C253.052165,762.984026 252.902123,762.009216 253.72695,762.009216 C254.551373,762.009216 255.564155,761.972748 256.539427,762.044899 C257.513892,762.117833 259.201055,762.586416 259.988372,762.406433 C260.775688,762.225666 261.525897,762.225666 262.05064,762.225666 L262.800849,762.225666 Z"></path>
          </g>
        </g>
      </Icon>

      <Value data-testid="percentage-change_value">{change}%</Value>
    </StyledPercentageChange>
  );
};

PercentageChange.propTypes = {
  value: PropTypes.number.isRequired,
};

export default PercentageChange;
